import { useEffect } from 'react'
import { useAppSelector } from 'reduxTyped'

import { getUserRole, UserRoles } from 'common/userRoles'
import { ZendeskApi } from 'shared/api/requests/zendesk'
import { getAccountID } from 'utils/accountId'

import errorTrackingService from '../errorTrackingService'

export const useSessionInfo = () => {
  const userRole = useAppSelector(getUserRole)
  useEffect(() => {
    const accountId = getAccountID()
    if (!accountId) return

    if (![UserRoles.ADMIN, UserRoles.EDITOR].includes(userRole)) return

    ZendeskApi.sessionPageId({
      body: { page_id: accountId },
    }).catch((err) => {
      errorTrackingService.logError('Failed to store session info for Zendesk', {
        scope: 'support',
        section: 'session_info',
        fingerprint: 'zendesk-session-info',
        extra: {
          accountId,
          err,
        },
      })
    })
  }, [userRole])
}
